"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.APIErrorCode = exports.APIError = void 0;
var APIError = /** @class */ (function (_super) {
    __extends(APIError, _super);
    function APIError(_a) {
        var code = _a.code, _b = _a.extra, extra = _b === void 0 ? null : _b;
        var _this = _super.call(this, code) || this;
        _this.code = code;
        _this.extra = extra;
        Object.setPrototypeOf(_this, APIError.prototype);
        return _this;
    }
    /*
     * Gets the code of the error
     */
    APIError.prototype.getCode = function () {
        return this.code;
    };
    APIError.prototype.getExtra = function () {
        return this.extra;
    };
    /*
     * Gets the message of the error
     */
    APIError.prototype.getMessage = function () {
        var _a;
        var lowerStr = this.getCode()
            .replace(/([a-z])([A-Z])/g, "$1 $2")
            .toLowerCase();
        return ((_a = lowerStr[0]) !== null && _a !== void 0 ? _a : "").toUpperCase() + lowerStr.slice(1);
    };
    return APIError;
}(Error));
exports.APIError = APIError;
var APIErrorCode;
(function (APIErrorCode) {
    APIErrorCode["EmailAlreadyExists"] = "emailAlreadyExists";
    APIErrorCode["InvalidCredentials"] = "invalidCredentials";
    APIErrorCode["IncorrectAppCode"] = "incorrectAppCode";
    APIErrorCode["InternalServerError"] = "internalServerError";
    APIErrorCode["ValidationError"] = "validationError";
    APIErrorCode["TeamNameAlreadyExists"] = "teamNameAlreadyExists";
    APIErrorCode["InvalidYouthKid"] = "invalidYouthKid";
    APIErrorCode["InvalidTeam"] = "invalidTeam";
    APIErrorCode["InvalidAccount"] = "invalidAccount";
    APIErrorCode["InvalidToken"] = "invalidToken";
    APIErrorCode["MissingToken"] = "missingToken";
    APIErrorCode["MissingParameters"] = "missingParameters";
    APIErrorCode["InvalidParameters"] = "invalidParameters";
    APIErrorCode["InvalidRoleType"] = "invalidRoleType";
    APIErrorCode["InvalidPermissions"] = "invalidPermissions";
})(APIErrorCode || (exports.APIErrorCode = APIErrorCode = {}));
